<span [formGroup]="configurationForm">
    <div>
        <mat-checkbox
        class="checkboxAll"
        (change)="setAll($event.checked)"
        [checked]="allcheck"
        [indeterminate]="somecheck"
        [disabled]="configurationForm.disabled">Quote Details (Select All/Select None)
        </mat-checkbox>
    </div>
    <div *ngIf="displaySupplierProperty">
      <mat-checkbox formControlName="supplier" [checked]="configurationForm.controls.supplier.value">Supplier
      </mat-checkbox>
  </div>
    <div *ngIf="configurationForm.controls?.productType">
        <mat-checkbox formControlName="productType" [checked]="configurationForm.controls.productType.value">Product Type
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox formControlName="usage" [checked]="configurationForm.controls.usage.value">Usage
        </mat-checkbox>
    </div>
    <div *ngIf="isSupplierOrSupplierManagerOrSalesManager()">
        <mat-checkbox formControlName="totalCommission" [checked]="configurationForm.controls.totalCommission.value">Total Commission ($)
        </mat-checkbox>
    </div>
    <div *ngIf="isSupplierOrSupplierManagerOrSalesManager()">
        <mat-checkbox formControlName="annualCommission" [checked]="configurationForm.controls.annualCommission.value">Annual Commission ($/year)
        </mat-checkbox>
    </div>
    <div>
      <mat-checkbox formControlName="totalCost" [checked]="configurationForm.controls.totalCost.value">Total Cost ($)
      </mat-checkbox>
  </div>
   <div>
      <mat-checkbox formControlName="annualCost" [checked]="configurationForm.controls.annualCost.value">Annual Cost ($/year)
      </mat-checkbox>
   </div>
</span>
